import React, { useState } from "react";
import { useSetting } from "../../context/SettingContext";

// import JS files
// import { showNumSix } from "../../constants/constants";

const OrderCardDiff = ({ item, adminNeedDifference }) => {
  const { showNumSix, reverseShowNums } = useSetting();

  return (
    <>
      {adminNeedDifference == true ? (
        <>
          {!item.admin_change_item ? (
            <>
              {reverseShowNums ? (
                <span>
                {showNumSix ? <>{item.size_six_num} / </> : ""}
                {item.size_five_num} / {item.size_four_num} /{" "}
                {item.size_three_num} / {item.size_two_num} /{" "}
                {item.size_one_num}
              </span>
              ) : (
                <span>
                {item.size_one_num} / {item.size_two_num} /
                {item.size_three_num} / {item.size_four_num} /{" "}
                {item.size_five_num}{" "}
                {showNumSix ? <>/{item.size_six_num} / </> : ""}
              </span>
               
              )}
            </>
          ) : (
            <>
              <div
                className={
                  reverseShowNums ? "" : "flex flex-row-reverse justify-end"
                }
              >
                {showNumSix ? (
                  <>
                    <span
                      className={
                        item.size_six_num - item.admin_size_six_num <= 0
                          ? "text-green-700"
                          : "text-red-700"
                      }
                    >
                      {" "}
                      {Math.abs(item.size_six_num - item.admin_size_six_num)}
                    </span>
                    {" / "}
                  </>
                ) : (
                  ""
                )}
                <span
                  className={
                    item.size_five_num - item.admin_size_five_num <= 0
                      ? "text-green-700"
                      : "text-red-700"
                  }
                >
                  {Math.abs(item.size_five_num - item.admin_size_five_num)}
                </span>
                {" / "}
                <span
                  className={
                    item.size_four_num - item.admin_size_four_num <= 0
                      ? "text-green-700"
                      : "text-red-700"
                  }
                >
                  {Math.abs(item.size_four_num - item.admin_size_four_num)}
                </span>
                {" / "}
                <span
                  className={
                    item.size_three_num - item.admin_size_three_num <= 0
                      ? "text-green-700"
                      : "text-red-700"
                  }
                >
                  {Math.abs(item.size_three_num - item.admin_size_three_num)}
                </span>
                {" / "}
                <span
                  className={
                    item.size_two_num - item.admin_size_two_num <= 0
                      ? "text-green-700"
                      : "text-red-700"
                  }
                >
                  {Math.abs(item.size_two_num - item.admin_size_two_num)}
                </span>
                {" / "}
                <span
                  className={
                    item.size_one_num - item.admin_size_one_num <= 0
                      ? "text-green-700"
                      : "text-red-700"
                  }
                >
                  {Math.abs(item.size_one_num - item.admin_size_one_num)}
                </span>
              </div>
            </>
          )}
        </>
      ) : undefined}
    </>
  );
};

export default OrderCardDiff;
